const toggleRepertoryItem = () => {
    const items = document.querySelectorAll('.search-repertory__headline');
    items.forEach((item) => {
        item.addEventListener('click', (evt) => {
            const descriptionHolder = item.nextElementSibling;

            if (!item.classList.contains('search-repertory__headline--active')) {
                const description = descriptionHolder.children[0];
                descriptionHolder.style.height = `${description.clientHeight}px`;
            } else {
                descriptionHolder.style.height = `0px`;
            }

            item.classList.toggle('search-repertory__headline--active');
        });
    });
}

export {toggleRepertoryItem};
